export const isUrl = (url: string) => {
    try {
        new URL(url);
        return true;
    } catch (e) {
        return false;
    }
};

export const isPrivateIp = (url: string) => {
    const hostname = new URL(url).hostname;
    const privateIpRanges = [
        /^10\./,
        /^172\.(1[6-9]|2[0-9]|3[0-1])\./,
        /^192\.168\./,
        /^localhost$/,
        /^127\.0\.0\.1$/,
        /^169\.254\./,
        /^[0-9a-fA-F]{1,4}:((100::)|(::1)|(fe80::))/,
    ];
    return privateIpRanges.some(range => range.test(hostname));
};
